module.exports = __webpack_public_path__ + "static/gift-box-5dcd688d7d49f32b976566ba73d44b60.jpg";